import React, {PropsWithChildren, useContext, useEffect} from 'react';
import {useCollapse} from '../../use-collapse';
import {StepContentContext} from './step-content-context';
import styles from './styles.module.less';
import {join} from '../../../utils/join';

type Props = {
	containerClassName?: string;
	contentClassName?: string;
} & PropsWithChildren;

export function StepContent(props: Props) {
	const context = useContext(StepContentContext);
	const [collapseProps, , setCollapse] = useCollapse(!context.active);

	useEffect(() => {
		setCollapse(!context.active);
	}, [context.active]);

	return <div {...collapseProps} className={props.containerClassName}>
		<div className={join(styles.stepContent, props.contentClassName)}>{props.children}</div>
	</div>;

}
